<template>
  <div class="create-rank-report">
    <div v-if="selectedRankReport" class="create-rank-report__title">Edit Rank Report</div>
    <div v-else class="create-rank-report__title">Create New Rank Report</div>
    <label class="create-section__input" v-if="selectedRankReport">
      <span class="create-section__label">Record Id</span>
      <div class="create-section__link-wrapper"
           :class="{'create-section__link-wrapper_single': isDomainDropdownHidden}">
        <span>{{ rankReport.id }}</span>
      </div>
    </label>
    <label class="create-rank-report__input">
      <span class="create-rank-report__label">Type</span>
      <div class="create-rank-report__link-wrapper" :class="{'create-rank-report__link-wrapper_single': isDomainDropdownHidden}">
        <base-select
          border-less="true"
          class="create-rank-report__type"
          :class="{'form-control_error': externalErrors.type_id}"
          :options="opts.types"
          v-model="rankReport.type_id"
          alignLeft="true"
          :max-height-list="450"
          :titleStyle="titleStyle"
          :headerStyle="selectedRankReport ? '' : selectTypeStyle"
          :disabled="selectedRankReport"
        />
        <span class="create-rank-report__error-message" v-if="externalErrors.type_id">{{externalErrors.type_id}}</span>
      </div>
    </label>
    <label class="create-rank-report__input">
      <span class="create-rank-report__label">Source</span>
      <div class="create-rank-report__link-wrapper" :class="{'create-rank-report__link-wrapper_single': isDomainDropdownHidden}">
          <base-select
            border-less="true"
            class="create-rank-report__source"
            :class="{'form-control_error': externalErrors.source_id}"
            :options="opts.sources"
            v-model="rankReport.source_id"
            alignLeft="true"
            :max-height-list="450"
            :titleStyle="titleStyle"
            :headerStyle="selectedRankReport ? '' : selectTypeStyle"
            :disabled="selectedRankReport"
          />
          <span class="create-rank-report__error-message" v-if="externalErrors.source_id">{{externalErrors.source_id}}</span>
      </div>
    </label>
    <label class="create-section__input" v-if="selectedRankReport">
      <span class="create-section__label">Submitted</span>
      <div class="create-section__link-wrapper" :class="{'create-section__link-wrapper_single': isDomainDropdownHidden}">
          <span>{{ rankReport.timestamp_submitted || '-' }}</span>
      </div>
    </label>
    <label class="create-section__input" v-if="selectedRankReport">
      <span class="create-section__label">Started</span>
      <div class="create-section__link-wrapper" :class="{'create-section__link-wrapper_single': isDomainDropdownHidden}">
          <span>{{ rankReport.timestamp_started || '-' }}</span>
      </div>
    </label>
    <label class="create-section__input" v-if="selectedRankReport">
      <span class="create-section__label">Completed</span>
      <div class="create-section__link-wrapper" :class="{'create-section__link-wrapper_single': isDomainDropdownHidden}">
          <span>{{ rankReport.timestamp_completed || '-' }}</span>
      </div>
    </label>
    <label class="create-section__input" v-if="selectedRankReport">
      <span class="create-section__label">Deleted</span>
      <div class="create-section__link-wrapper" :class="{'create-section__link-wrapper_single': isDomainDropdownHidden}">
          <span>{{ rankReport.timestamp_deleted || '-' }}</span>
      </div>
    </label>
    <div class="create-rank-report__controls">
      <button class="create-rank-report__button create-rank-report__button_cancel"
              @click.prevent="close()">Cancel
      </button>
      <button class="create-rank-report__button create-rank-report__button_submit"
              @click.prevent="apply()"
              v-if="!selectedRankReport">
        Apply
      </button>
      <button class="create-rank-report__button create-rank-report__button_submit"
              @click.prevent="edit()"
              v-if="selectedRankReport">
        {{ rankReport.timestamp_deleted ? 'Restore to client view' : 'Pause from client view'}}
      </button>
    </div>
  </div>
</template>

<script>
import Filters from '@/common/Filters'
import { mapState } from 'vuex'
import validator from 'validator'
import _ from 'lodash'
import BaseModalMixins from '@/common/BaseModalMixins'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}

/**
 * Popup is shown when we want to add new URL
 */
export default {
  name: 'CreateUpdateRankReportPopup',
  mixins: [BaseModalMixins],
  components: {
  },
  props: {
    selectedRankReport: {
      type: Object
    },
    opts: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      // source_id: 69 - Authority Labs
      // type_id: 72 - Non Priority
      rankReport: _.cloneDeep(this.selectedRankReport) || {
        source_id: 160,
        type_id: 72
      },
      externalErrors: {
        type_id: null,
        source_id: null
      },
      isValidating: false,
      // should domain name selector be hidden or not
      isDomainDropdownHidden: true,
      elementStyle: {},
      titleStyle: {
        overflow: 'visible'
      }
    }
  },
  computed: {
    ...mapState('rankZoneCommon', {
      selectTypeStyle () {
        return SELECT_STYLE
      }
    })
  },
  methods: {
    /**
     * Handling decline creating new URL & hiding component
     */
    close () {
      this.$emit('cancel')
    },
    convertToOptions (item) {
      return {
        value: item._id,
        label: item.label
      }
    },
    showErrors (errors) {
      for (const k in this.externalErrors) {
        this.externalErrors[k] = null
      }

      for (const k in errors) {
        this.externalErrors[k] = errors[k]
      }
    },
    apply () {
      this.$emit('apply', this.rankReport)
    },
    edit () {
      this.$emit('edit', this.rankReport)
    }
  },
  filters: {
    ...Filters
  }
}
</script>

<style lang="scss">
  .create-rank-report {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
    }

    &__input {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-top: 30px;

      &_invalid[type='text'] {
        border: 1px solid $rfx-red;
        border-radius: 4px;
      }
    }

    &__label {
      display: block;
      font-weight: 600;
      margin-bottom: 5px;
      color: $rfx-dark-march;
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }
    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;

        &:disabled {
          pointer-events: none;
          background-color: #fff;
          color: $rfx-neutral-grey;
          cursor: default;
        }
      }

      &_delete {
        background-color: $rfx-medium-orange;
        color: #fff
      }

      &_disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }
    }
    &__link {
      &-wrapper {
        position: relative;
        margin-top: 30px;

        &_single{
          margin-top: 0;
        }
      }

      &-field[type='text'] {
        width: 100%;
        box-sizing: border-box;
        padding-right: 60px;
        font-weight: 500;
        @include ellipsis;
      }
    }

    &__error-message {
        color: $rfx-red;
        font-size: 10px;
        margin-top: 5px;
      }

  }

  .form-control {
    height: 50px;
    padding: 0 20px;
    border: 2px solid $rfx-light-steel;
    outline: none;
    border-radius: $rfx-default-border-radius;
    font-size: 14px;
    font-weight: 600;
    color: $rfx-dark-march;

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
    }

    &:disabled {
      background-color: $rfx-light-steel;
    }

    &_error{
       border-color: $rfx-red;
      color: $rfx-red;

       &::placeholder {
         color: $rfx-red;
         font-size: 13px;
       }

     }
  }

  .description {
    width: 100%;
    height: 90%;
    padding: 0;
    resize: none;
    outline: none;
    border: none;
    font-size: 14px;

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
      margin-top: -5px;
    }

    &__wrapper {
      padding: 10px 20px;
      height: auto;
    }
  }

</style>
